import { IInitialDataIntegrationState } from 'interfaces/dataIntegration.interface';
import * as types from './dataIntegration.types';
import {
  IcreateAudienceAPIBody,
  IcreateMappingAPIBody,
  IcreateMappingFieldAPIBodyItem,
  IcreatePointsOfSaleDictionaryAPIBodyItem,
  IgetAudiencesAPIResponseItem,
  IgetFilePatternsAPIResponseItem,
  IgetHistoryAPIBody,
  IgetHistoryAPIResponseData,
  IgetHistoryAPIResponseItem,
  IgetMappingFieldsAPIResponseItem,
  IgetMappingsAPIResponseItem,
  IgetPointsOfSaleDictionaryAPIResponseItem,
} from 'api/endpoints/dataIntegration/dataIntegration.response.interface';

export type TdataIntegrationDispatchReducer =
  // History /////////////////////////////////////////////////////////
  | {
      type: typeof types.SET_IMPORT_FILES_HISTORY;
      payload: {
        history: IgetHistoryAPIResponseData;
        body: IgetHistoryAPIBody;
      };
    }
  | {
      type: typeof types.SET_IS_LOADING_GET_IMPORT_FILES_HISTORY;
      payload: boolean;
    }
  | {
      type: typeof types.SET_SELECTED_IMPORT_FILES_HISTORY;
      payload: IgetHistoryAPIResponseItem | null;
    }
  // Audiences /////////////////////////////////////////////////////
  | {
      type: typeof types.SET_AUDIENCES;
      payload: Array<IgetAudiencesAPIResponseItem>;
    }
  | {
      type: typeof types.SET_IS_LOADING_GET_AUDIENCES;
      payload: boolean;
    }
  | {
      type: typeof types.SET_AUDIENCE_SELECTED;
      payload: IgetAudiencesAPIResponseItem | null;
    }
  | {
      type: typeof types.CREATE_AUDIENCE;
      payload: IgetAudiencesAPIResponseItem;
    }
  | {
      type: typeof types.SET_IS_LOADING_CREATE_AUDIENCE;
      payload: boolean;
    }
  | {
      type: typeof types.UPDATE_AUDIENCE;
      payload: { id: string; audience: IcreateAudienceAPIBody };
    }
  | {
      type: typeof types.SET_IS_LOADING_UPDATE_AUDIENCE;
      payload: boolean;
    }
  // Mappings fields /////////////////////////////////////////////////////
  | {
      type: typeof types.SET_MAPPING_FIELDS;
      payload: Array<IgetMappingFieldsAPIResponseItem>;
    }
  | {
      type: typeof types.SET_IS_LOADING_GET_MAPPING_FIELDS;
      payload: boolean;
    }
  | {
      type: typeof types.SET_MAPPING_FIELDS_AUDIENCE_SELECTED;
      payload: string | null;
    }
  | {
      type: typeof types.SET_MAPPING_FIELD_SELECTED;
      payload: IgetMappingFieldsAPIResponseItem | null;
    }
  | {
      type: typeof types.CREATE_MAPPING_FIELD;
      payload: IgetMappingFieldsAPIResponseItem;
    }
  | {
      type: typeof types.SET_IS_LOADING_CREATE_MAPPING_FIELD;
      payload: boolean;
    }
  | {
      type: typeof types.UPDATE_MAPPING_FIELD;
      payload: { id: string; mappingField: IcreateMappingFieldAPIBodyItem };
    }
  | {
      type: typeof types.SET_IS_LOADING_UPDATE_MAPPING_FIELD;
      payload: boolean;
    }
  | {
      type: typeof types.DELETE_MAPPING_FIELD;
      payload: { id: string };
    }
  | {
      type: typeof types.SET_IS_LOADING_DELETE_MAPPING_FIELD;
      payload: {
        mappingFieldId: string | null;
        isLoading: boolean;
      };
    } // Mappings /////////////////////////////////////////////////////
  | {
      type: typeof types.SET_MAPPINGS;
      payload: Array<IgetMappingsAPIResponseItem>;
    }
  | {
      type: typeof types.SET_IS_LOADING_GET_MAPPINGS;
      payload: boolean;
    }
  | {
      type: typeof types.SET_MAPPING_SELECTED;
      payload: IgetMappingsAPIResponseItem | null;
    }
  | {
      type: typeof types.CREATE_MAPPING;
      payload: IgetMappingsAPIResponseItem;
    }
  | {
      type: typeof types.SET_IS_LOADING_CREATE_MAPPING;
      payload: boolean;
    }
  | {
      type: typeof types.SET_CREATE_MAPPING_SELECTED;
      payload: IcreateMappingAPIBody | null;
    }
  | {
      type: typeof types.UPDATE_MAPPING;
      payload: { id: string; mapping: Partial<IcreateMappingAPIBody> };
    }
  | {
      type: typeof types.SET_IS_LOADING_UPDATE_MAPPING;
      payload: boolean;
    }
  | {
      type: typeof types.DELETE_MAP;
      payload: { id: string };
    }
  | {
      type: typeof types.SET_IS_LOADING_DELETE_MAP;
      payload: {
        mapId: string | null;
        isLoading: boolean;
      };
    }
  | {
      type: typeof types.SET_CSV_SELECTED;
      payload: {
        papa: Papa.ParseResult<unknown> | null;
        file: File | null | undefined;
      };
    }
  | {
      type: typeof types.SET_IS_LOADING_CSV_SELECTED;
      payload: boolean;
    }
  | {
      type: typeof types.SET_RECORD_TO_UPDATE;
      payload: string | null;
    }
  // Points of sale dictionaries /////////////////////////////////////////////////////
  | {
      type: typeof types.SET_POINTS_OF_SALE_DICTIONARY;
      payload: Array<IgetPointsOfSaleDictionaryAPIResponseItem>;
    }
  | {
      type: typeof types.SET_IS_LOADING_GET_POINTS_OF_SALE_DICTIONARY;
      payload: boolean;
    }
  | {
      type: typeof types.SET_POINT_OF_SALE_DICTIONARY_SELECTED;
      payload: IgetPointsOfSaleDictionaryAPIResponseItem | null;
    }
  | {
      type: typeof types.CREATE_POINTS_OF_SALE_DICTIONARY;
      payload: IgetPointsOfSaleDictionaryAPIResponseItem;
    }
  | {
      type: typeof types.SET_IS_LOADING_CREATE_POINTS_OF_SALE_DICTIONARY;
      payload: boolean;
    }
  | {
      type: typeof types.UPDATE_POINTS_OF_SALE_DICTIONARY;
      payload: {
        id: string;
        pointsOfSaleDictionary: Partial<IcreatePointsOfSaleDictionaryAPIBodyItem>;
      };
    }
  | {
      type: typeof types.SET_IS_LOADING_UPDATE_POINTS_OF_SALE_DICTIONARY;
      payload: boolean;
    }
  | {
      type: typeof types.DELETE_POINTS_OF_SALE_DICTIONARY;
      payload: { id: string };
    }
  | {
      type: typeof types.SET_IS_LOADING_DELETE_POINTS_OF_SALE_DICTIONARY;
      payload: {
        pointOfSaleDictionaryId: string | null;
        isLoading: boolean;
      };
    }
  // Files Patterns /////////////////////////////////////////////////////
  | {
      type: typeof types.SET_FILE_PATTERNS;
      payload: Array<IgetFilePatternsAPIResponseItem>;
    }
  | {
      type: typeof types.SET_IS_LOADING_GET_FILE_PATTERNS;
      payload: boolean;
    }
  | {
      type: typeof types.CREATE_FILE_PATTERN;
      payload: IgetFilePatternsAPIResponseItem;
    }
  | {
      type: typeof types.SET_IS_LOADING_CREATE_FILE_PATTERN;
      payload: boolean;
    }
  // Upload files
  | {
      type: typeof types.SET_IS_LOADING_UPLOAD_FILES;
      payload: boolean;
    }
  | {
      type: typeof types.SET_IS_LOADING_REPROCESS_IMPORT;
      payload: boolean;
    }
  | {
      type: typeof types.SET_IS_LOADING_ARCHIVE_FILE_HISTORY;
      payload: {
        importHistoryIds: Array<string> | null;
        isLoading: boolean;
      };
    };

export default function dataIntegrationReducer(
  state: IInitialDataIntegrationState,
  action: TdataIntegrationDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    // History /////////////////////////////////////////////////////////
    case types.SET_IMPORT_FILES_HISTORY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        importFilesHistory: payload.history,
        importFilesHistoryBody: payload.body,
      };
      return newState;
    }

    case types.SET_IS_LOADING_GET_IMPORT_FILES_HISTORY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingGetImportFilesHistory: payload,
      };
      return newState;
    }

    case types.SET_SELECTED_IMPORT_FILES_HISTORY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        selectedImportFilesHistory: payload,
      };
      return newState;
    }

    // Audiences /////////////////////////////////////////////////////
    case types.SET_AUDIENCES: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        audiences: payload,
      };
      return newState;
    }

    case types.SET_IS_LOADING_GET_AUDIENCES: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingGetAudiences: payload,
      };
      return newState;
    }

    case types.SET_AUDIENCE_SELECTED: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        audienceSelected: payload,
      };
      return newState;
    }

    case types.CREATE_AUDIENCE: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        audiences: [...state.audiences, payload],
      };
      return newState;
    }

    case types.SET_IS_LOADING_CREATE_AUDIENCE: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingCreateAudience: payload,
      };
      return newState;
    }

    case types.UPDATE_AUDIENCE: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        audiences: state.audiences.map((audience) =>
          audience.id === payload.id ? { ...audience, ...payload.audience } : audience
        ),
      };
      return newState;
    }

    case types.SET_IS_LOADING_UPDATE_AUDIENCE: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingUpdateAudience: payload,
      };
      return newState;
    }

    // Mapping fields /////////////////////////////////////////////////////
    case types.SET_MAPPING_FIELDS: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappingFields: payload,
      };
      return newState;
    }

    case types.SET_IS_LOADING_GET_MAPPING_FIELDS: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingGetMappingFields: payload,
      };
      return newState;
    }

    case types.SET_MAPPING_FIELDS_AUDIENCE_SELECTED: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappingFieldsAudienceSelected: payload,
      };
      return newState;
    }

    case types.SET_MAPPING_FIELD_SELECTED: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappingFieldSelected: payload,
      };
      return newState;
    }

    case types.CREATE_MAPPING_FIELD: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappingFields: [...state.mappingFields, payload],
      };
      return newState;
    }

    case types.SET_IS_LOADING_CREATE_MAPPING_FIELD: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingCreateMappingField: payload,
      };
      return newState;
    }

    case types.UPDATE_MAPPING_FIELD: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappingFields: state.mappingFields.map((mappingField) =>
          mappingField.id === payload.id
            ? { ...mappingField, ...payload.mappingField }
            : mappingField
        ),
      };
      return newState;
    }

    case types.SET_IS_LOADING_UPDATE_MAPPING_FIELD: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingUpdateMappingField: payload,
      };
      return newState;
    }

    case types.DELETE_MAPPING_FIELD: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappingFields: state.mappingFields.filter(
          (mappingField) => mappingField.id !== payload.id
        ),
      };
      return newState;
    }

    case types.SET_IS_LOADING_DELETE_MAPPING_FIELD: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingDeleteMappingField: {
          mappingFieldId: payload.mappingFieldId,
          isLoading: payload.isLoading,
        },
      };
      return newState;
    }

    // Mappings /////////////////////////////////////////////////////
    case types.SET_MAPPINGS: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappings: payload,
      };
      return newState;
    }

    case types.SET_IS_LOADING_GET_MAPPINGS: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingGetMappings: payload,
      };
      return newState;
    }

    case types.SET_MAPPING_SELECTED: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappingSelected: payload,
      };
      return newState;
    }

    case types.CREATE_MAPPING: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappings: [...state.mappings, payload],
      };
      return newState;
    }

    case types.SET_IS_LOADING_CREATE_MAPPING: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingCreateMapping: payload,
      };
      return newState;
    }

    case types.SET_CREATE_MAPPING_SELECTED: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        createMappingSelected: payload,
      };
      return newState;
    }

    case types.UPDATE_MAPPING: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappings: state.mappings.map((map) =>
          map.id === payload.id ? { ...map, ...payload.mapping } : map
        ),
        mappingSelected:
          state.mappingSelected && state.mappingSelected.id === payload.id
            ? { ...state.mappingSelected, ...payload.mapping }
            : state.mappingSelected,
      };
      return newState;
    }

    case types.SET_IS_LOADING_UPDATE_MAPPING: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingUpdateMapping: payload,
      };
      return newState;
    }

    case types.DELETE_MAP: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        mappings: state.mappings.filter((map) => map.id !== payload.id),
      };
      return newState;
    }

    case types.SET_IS_LOADING_DELETE_MAP: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingDeleteMap: {
          mapId: payload.mapId,
          isLoading: payload.isLoading,
        },
      };
      return newState;
    }

    case types.SET_CSV_SELECTED: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        csvSelected: {
          papa: payload.papa,
          file: payload.file,
        },
      };
      return newState;
    }

    case types.SET_IS_LOADING_CSV_SELECTED: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingCSVSelected: payload,
      };
      return newState;
    }

    case types.SET_RECORD_TO_UPDATE: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        recordToUpdate: payload,
      };
      return newState;
    }

    // Points of sale dictionaries /////////////////////////////////////////////////////
    case types.SET_POINTS_OF_SALE_DICTIONARY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        pointsOfSaleDictionary: payload,
      };
      return newState;
    }

    case types.SET_IS_LOADING_GET_POINTS_OF_SALE_DICTIONARY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingGetPointsOfSaleDictionary: payload,
      };
      return newState;
    }

    case types.SET_POINT_OF_SALE_DICTIONARY_SELECTED: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        pointOfSaleDictionarySelected: payload,
      };
      return newState;
    }

    case types.CREATE_POINTS_OF_SALE_DICTIONARY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        pointsOfSaleDictionary: [...state.pointsOfSaleDictionary, payload],
      };
      return newState;
    }

    case types.SET_IS_LOADING_CREATE_POINTS_OF_SALE_DICTIONARY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingCreatePointsOfSaleDictionary: payload,
      };
      return newState;
    }

    case types.UPDATE_POINTS_OF_SALE_DICTIONARY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        pointsOfSaleDictionary: state.pointsOfSaleDictionary.map(
          (pointsOfSaleDictionary) =>
            pointsOfSaleDictionary.id === payload.id
              ? { ...pointsOfSaleDictionary, ...payload.pointsOfSaleDictionary }
              : pointsOfSaleDictionary
        ),
      };
      return newState;
    }

    case types.SET_IS_LOADING_UPDATE_POINTS_OF_SALE_DICTIONARY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingUpdatePointsOfSaleDictionary: payload,
      };
      return newState;
    }

    case types.DELETE_POINTS_OF_SALE_DICTIONARY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        pointsOfSaleDictionary: state.pointsOfSaleDictionary.filter(
          (pointsOfSaleDictionary) => pointsOfSaleDictionary.id !== payload.id
        ),
      };
      return newState;
    }

    case types.SET_IS_LOADING_DELETE_POINTS_OF_SALE_DICTIONARY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingDeletePointOfSaleDictionary: {
          pointOfSaleDictionaryId: payload.pointOfSaleDictionaryId,
          isLoading: payload.isLoading,
        },
      };
      return newState;
    }

    // Files Patterns /////////////////////////////////////////////////////
    case types.SET_FILE_PATTERNS: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        filePatterns: payload,
      };
      return newState;
    }

    case types.SET_IS_LOADING_GET_FILE_PATTERNS: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingGetFilePatterns: payload,
      };
      return newState;
    }

    case types.CREATE_FILE_PATTERN: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        filePatterns: [...state.filePatterns, payload],
      };
      return newState;
    }

    case types.SET_IS_LOADING_CREATE_FILE_PATTERN: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingCreateFilePattern: payload,
      };
      return newState;
    }

    // Upload files /////////////////////////////////////////////////////
    case types.SET_IS_LOADING_UPLOAD_FILES: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingUploadFiles: payload,
      };
      return newState;
    }

    case types.SET_IS_LOADING_REPROCESS_IMPORT: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingReprocessImport: payload,
      };
      return newState;
    }

    case types.SET_IS_LOADING_ARCHIVE_FILE_HISTORY: {
      const newState: IInitialDataIntegrationState = {
        ...state,
        isLoadingArchiveFileHistory: {
          importHistoryIds: payload.importHistoryIds,
          isLoading: payload.isLoading,
        },
      };
      return newState;
    }

    default:
      return state;
  }
}
